/**
 * bz-brain-fog-guide.js — US MARKET VERSION
 * Brain Fog Editorial Guide — Page JavaScript
 * Inherits architecture from adhd-supplements-guide.js.
 * US lensing: $ pricing, /products/gaba-supplements + /products/dopamine-supplements CTAs.
 * Created: 2026-04-26 — session 32 wave 2.
 */

/* ─────────────────────────────────────────────────────────────────────
   1. SHARED CONFIG — US market
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

BZ.PRODUCTS = BZ.PRODUCTS || {};
if (!BZ.PRODUCTS.us) {
  BZ.PRODUCTS.us = {
    elite:    { name: 'FOCUS ELITE™',    shortName: 'ELITE',    price: '$65', priceSub: '$54.60/mo', url: '/products/gaba-supplements', cart: '/products/gaba-supplements', purpose: 'Stress-free focus, positive mood & brain health' },
    pro:      { name: 'FOCUS PRO™',      shortName: 'PRO',      price: '$40', priceSub: '$33.60/mo', url: '/products/dopamine-supplements', cart: '/products/dopamine-supplements', purpose: 'Strong focus, motivation & memory' },
    original: { name: 'FOCUS ORIGINAL™', shortName: 'ORIGINAL', price: '$25', priceSub: '$21.00/mo', url: '/products/brainzyme-original-milder-formula', cart: '/products/brainzyme-original-milder-formula', purpose: 'Mild everyday focus & calm mood' }
  };
}

/* ─────────────────────────────────────────────────────────────────────
   2. PRODUCT SHELF — ELITE + PRO dual primary (Brain Fog lane)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var market = 'us';
  var p = BZ.PRODUCTS[market];

  var PRODUCTS = [
    {
      key: 'original',
      name: p.original.name,
      pill: null,
      pillClass: '',
      purpose: p.original.purpose,
      price: p.original.price,
      priceSub: p.original.priceSub,
      oneTimeUrl: p.original.cart,
      subUrl: p.original.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Original_2025.png',
      recommended: false
    },
    {
      key: 'pro',
      name: p.pro.name,
      pill: 'MOTIVATED FOCUS',
      pillClass: 'pill--navy',
      purpose: p.pro.purpose + ' — dopamine pathway',
      price: p.pro.price,
      priceSub: p.pro.priceSub,
      oneTimeUrl: p.pro.cart,
      subUrl: p.pro.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Pro_2025.png',
      recommended: false,
      recBadge: 'For depletion & overload brain fog'
    },
    {
      key: 'elite',
      name: p.elite.name,
      pill: 'STRESS-FREE FOCUS',
      pillClass: 'pill--gold',
      purpose: p.elite.purpose + ' — GABA pathway',
      price: p.elite.price,
      priceSub: p.elite.priceSub,
      oneTimeUrl: p.elite.cart,
      subUrl: p.elite.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Elite_2025.png',
      recommended: true,
      recBadge: 'For stress & hormonal brain fog'
    }
  ];

  function renderCard(prod) {
    var recClass = prod.recommended ? ' shelf-card--recommended' : '';
    var recBadge = prod.recBadge ? '<div class="shelf-card-rec-badge">' + prod.recBadge + '</div>' : '';
    var pillHtml = prod.pill ? '<span class="pill ' + prod.pillClass + '">' + prod.pill + '</span>' : '';
    return '<div class="shelf-card' + recClass + '">' +
      recBadge +
      pillHtml +
      '<img class="shelf-card-img" src="' + prod.img + '" alt="' + prod.name + '" loading="lazy" onerror="this.style.display=\'none\'">' +
      '<h3 class="shelf-card-name">' + prod.name + '</h3>' +
      '<p class="shelf-card-purpose">' + prod.purpose + '</p>' +
      '<div class="shelf-card-price">' + prod.price + '</div>' +
      '<a class="shelf-card-cta" href="' + prod.oneTimeUrl + '">Buy Now — ' + prod.price + '</a>' +
      '<a class="shelf-card-sub-cta" href="' + prod.subUrl + '">Subscribe & Save — ' + prod.priceSub + '</a>' +
      '</div>';
  }

  function renderShelf() {
    var el = document.getElementById('bfShelfGrid');
    if (!el) return;
    el.innerHTML = PRODUCTS.map(renderCard).join('');
  }

  document.addEventListener('DOMContentLoaded', renderShelf);
})();

/* ─────────────────────────────────────────────────────────────────────
   3. PAGE INTERACTIONS (accordion, symptom checker, progress bar, stat counters)
   ───────────────────────────────────────────────────────────────────── */

/* Accordion toggle */
function toggleAccordion(btn) {
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  var panel = btn.nextElementSibling;
  var chevron = btn.querySelector('.accordion-chevron');
  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = null;
    panel.classList.remove('open');
    if (chevron) chevron.textContent = '+';
  } else {
    btn.setAttribute('aria-expanded', 'true');
    panel.classList.add('open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    if (chevron) chevron.textContent = '−';
  }
}

/* Brain fog symptom checker */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.sign-item.selectable');
    var countEl = document.getElementById('bfSymptomCount');
    var resultEl = document.getElementById('bfSymptomResult');
    var count = 0;

    var MESSAGES = [
      null,
      'One sign — the 7 daily moves section is a good starting point.',
      'A couple of signs — both dopamine and GABA support are worth exploring.',
      '[N] signs — this pattern suggests your focus pathways would benefit from targeted nutritional support.',
      '[N] of 6 signs — a cause-matched formula is likely to make a meaningful difference. Read on.',
      '[N] of 6 signs — a multi-factor brain fog pattern: consider the Starter Bundle to test both pathways.',
      '[N] of 6 signs — significant pattern. FOCUS ELITE™ (GABA) or FOCUS PRO™ (dopamine) based on your dominant cause.'
    ];

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var checked = item.getAttribute('aria-checked') === 'true';
        if (checked) {
          item.setAttribute('aria-checked', 'false');
          item.classList.remove('selected');
          count--;
        } else {
          item.setAttribute('aria-checked', 'true');
          item.classList.add('selected');
          count++;
        }
        if (countEl) countEl.textContent = count;
        if (resultEl) {
          if (count === 0) {
            resultEl.innerHTML = '';
            resultEl.style.display = 'none';
          } else {
            var msg = MESSAGES[count] || MESSAGES[MESSAGES.length - 1];
            resultEl.innerHTML = msg.replace('[N]', count);
            resultEl.style.display = 'block';
          }
        }
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
      });
    });
  });
})();

/* Buyer's guide checklist progress dots */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.guide-checklist li[data-check]');
    var dots = document.querySelectorAll('#bfCheckProgress .check-dot');
    var label = document.getElementById('bfCheckLabel');
    if (!items.length || !dots.length) return;

    var seen = new Set();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var n = entry.target.getAttribute('data-check');
          seen.add(n);
          dots.forEach(function (d) {
            if (seen.has(d.getAttribute('data-check'))) d.classList.add('active');
          });
          if (label) label.textContent = seen.size + '/6 explored';
        }
      });
    }, { threshold: 0.6 });

    items.forEach(function (item) { obs.observe(item); });
  });
})();

/* Animated stat counters */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-target]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target'));
        var isFloat = target % 1 !== 0;
        var suffix = el.innerHTML.replace(/[\d.]/g, '').trim();
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var val = isFloat ? (progress * target).toFixed(1) : Math.floor(progress * target);
          el.innerHTML = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { obs.observe(el); });
  });
})();

/* Progress bar + sticky CTA — Brain Fog lane, US, dual pathway */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('progressBar');
    var lbl = document.getElementById('progressLabel');
    var cta = document.getElementById('stickyCta');
    var ctaText = document.getElementById('stickyCtaText');
    var ctaLink = document.getElementById('stickyCtaLink');

    var MESSAGES = [
      { pct: 0.05, text: 'Plant-powered brain fog support', label: 'Learn more', url: '/products/gaba-supplements' },
      { pct: 0.20, text: 'The GABA pathway approach', label: 'See FOCUS ELITE™', url: '/products/gaba-supplements' },
      { pct: 0.40, text: '365-day money-back guarantee', label: 'Try Risk-Free', url: '/products/gaba-supplements' },
      { pct: 0.55, text: 'Motivated focus & sharp memory', label: 'See FOCUS PRO™', url: '/products/dopamine-supplements' },
      { pct: 0.70, text: '6,020+ verified reviews', label: 'Try FOCUS ELITE™', url: '/products/gaba-supplements' }
    ];

    function onScroll() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? scrolled / total : 0;

      if (bar) bar.style.width = (pct * 100) + '%';
      if (lbl) lbl.textContent = Math.round(pct * 100) + '%';

      if (cta) {
        if (pct > 0.10 && pct < 0.95) {
          cta.classList.add('visible');
        } else {
          cta.classList.remove('visible');
        }
      }

      var active = MESSAGES[0];
      for (var i = 0; i < MESSAGES.length; i++) {
        if (pct >= MESSAGES[i].pct) active = MESSAGES[i];
      }
      if (ctaText) ctaText.textContent = active.text;
      if (ctaLink) {
        ctaLink.textContent = active.label;
        ctaLink.href = active.url;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
